/*
 * Paragon Global Inquiry Modal opener
 *
 * Opens the site-wide inquiry pop-up (paragon-enquire-modal, rendered globally in
 * theme.liquid on non-product pages) from any "Inquire" CTA. Replaces the standalone
 * /pages/inquire page: CTAs now point to "#inquire" and open the modal in place.
 *
 * Self-contained and only active when the global modal is present, so it never
 * collides with paragon-product-action-bar.js (which handles the PDP's own modal).
 */
(function () {
  'use strict';

  function openDialog(dialog, trigger) {
    if (!dialog || typeof dialog.showModal !== 'function') return;
    if (trigger && trigger.id) dialog.setAttribute('data-return-focus', trigger.id);
    document.body.classList.add('paragon-modal-open');
    dialog.showModal();
  }

  /*
   * Reflect which piece the inquiry is about into the modal form. `piece` comes
   * from the trigger's data-piece attribute (a featured piece's title). Pre-fills
   * the message, records a hidden "Piece of Interest" field, and shows a banner.
   * Re-runs on every open and clears itself when opened from a generic CTA, so a
   * previous piece never lingers in the reused modal.
   */
  function applyPiece(modal, piece) {
    var form = modal.querySelector('form');
    if (!form) return;

    var hidden = form.querySelector('input[name="contact[Piece of Interest]"]');
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'contact[Piece of Interest]';
      form.appendChild(hidden);
    }
    hidden.value = piece || '';

    var body = form.querySelector('textarea[name="contact[body]"]');
    if (body) {
      if (piece && (!body.value.trim() || body.getAttribute('data-paragon-autofill') === '1')) {
        body.value = 'I would like to inquire about ' + piece + '.';
        body.setAttribute('data-paragon-autofill', '1');
      } else if (!piece && body.getAttribute('data-paragon-autofill') === '1') {
        body.value = '';
        body.removeAttribute('data-paragon-autofill');
      }
    }

    var banner = form.parentNode.querySelector('[data-paragon-piece-ref]');
    if (piece) {
      if (!banner) {
        banner = document.createElement('div');
        banner.className = 'paragon-inquiry__product-ref';
        banner.setAttribute('data-paragon-piece-ref', '');
        form.parentNode.insertBefore(banner, form);
      }
      banner.textContent = '';
      var strong = document.createElement('strong');
      strong.textContent = 'ABOUT THIS PIECE';
      banner.appendChild(strong);
      banner.appendChild(document.createTextNode(piece));
      banner.style.display = '';
    } else if (banner) {
      banner.style.display = 'none';
    }
  }

  function isInquireTrigger(el) {
    if (el.matches('[data-paragon-open-modal="paragon-enquire-modal"]')) return true;
    var href = el.getAttribute('href') || '';
    // Match the in-page anchor and any lingering links to the old page.
    return href === '#inquire' || /\/pages\/inquire\/?($|[?#])/.test(href);
  }

  function init() {
    var modal = document.getElementById('paragon-enquire-modal');
    if (!modal) return;

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('a[href], [data-paragon-open-modal]');
      if (!trigger || !isInquireTrigger(trigger)) return;
      e.preventDefault();
      applyPiece(modal, trigger.getAttribute('data-piece'));
      openDialog(modal, trigger);
    });

    var closeBtns = modal.querySelectorAll('[data-paragon-modal-close]');
    for (var i = 0; i < closeBtns.length; i++) {
      closeBtns[i].addEventListener('click', function () {
        modal.close();
      });
    }

    // Click-outside-to-close: on a native <dialog>, a backdrop click targets the dialog.
    modal.addEventListener('click', function (e) {
      if (e.target === modal) modal.close();
    });

    modal.addEventListener('close', function () {
      document.body.classList.remove('paragon-modal-open');
      var returnId = modal.getAttribute('data-return-focus');
      if (returnId) {
        var el = document.getElementById(returnId);
        if (el && typeof el.focus === 'function') el.focus();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
